import { render } from "./requirements-to-participate.component.vue?vue&type=template&id=776b77ff&ts=true"
import script from "./requirements-to-participate.component.vue?vue&type=script&lang=ts"
export * from "./requirements-to-participate.component.vue?vue&type=script&lang=ts"

import "./requirements-to-participate.component.vue?vue&type=style&index=0&id=776b77ff&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__